import { render, staticRenderFns } from "./StatementDescription.vue?vue&type=template&id=08d0b158&"
import script from "./StatementDescription.vue?vue&type=script&lang=js&"
export * from "./StatementDescription.vue?vue&type=script&lang=js&"
import style0 from "./StatementDescription.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports